import React from 'react'

const DialogApkMatchList = ({ data = {} }) => {
    return (
        <div className="track-body-box channel-apk-list">
            <div className="box-item box-item-title">
                <div className="track-body-title-bold">渠道包名称</div>
            </div>
            {Object.keys(data).map((channelName, index) => (
                <div className="box-item" key={index}>
                    <div className="item-left">
                        <div>{channelName}</div>
                        <div className="url ellipsis">
                            {data[channelName].type === 'url' && data[channelName].value
                                ? data[channelName].value
                                : null}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default DialogApkMatchList
